import React from 'react';

function Footer() {
    return (
        <React.Fragment>
        <footer>
            <p>Code(back and front) is visible on <a href='https://github.com/Justasrimavicius/microgoogol'>Github</a></p>
            <p>Made by <a href='http://jusridev.com'>Justinas</a></p>
            <p>Design inspiration from <a href='https://www.duolingo.com/'>Duolingo.com</a></p>
        </footer>

        </React.Fragment>

    );
}

export default Footer;